import React from "react";
import DOMPurify from "dompurify";
import "../Styles/SafeMap.css";

const SafeMap = ({ mapHtml }) => {
  // Sanitize while allowing iframe
  const cleanHtml = DOMPurify.sanitize(mapHtml, {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: [
      "allow",
      "allowfullscreen",
      "frameborder",
      "scrolling",
      "loading",
      "referrerpolicy",
      "style",
    ],
  });

  return (
    <div className="safeMap-container">
      <div
        className="safeMap-content"
        dangerouslySetInnerHTML={{ __html: cleanHtml }}
      />
    </div>
  );
};

export default SafeMap;
